import styled from 'styled-components'
import { Button } from '@all-turtles/mmhmm-ui-kit'

import { Type } from 'styles'

export const StyledButton = styled(Button)`
  ${Type.body30};
`
